import React, { useState } from "react";
import Navbar from "../components/Navbar";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const jobOpenings = [
  {
    id: 1,
    title: "Frontend Developer (React)",
    location: "Lahore, Pakistan",
    type: "Full-Time",
    description:
      "We’re looking for a passionate Frontend Developer experienced with React to join our growing team and help build world-class web experiences.",
  },
  {
    id: 2,
    title: "Marketing Executive",
    location: "Karachi, Pakistan",
    type: "Full-Time",
    description:
      "Join our marketing department and help drive the brand’s presence across digital and retail platforms. Creativity and initiative are key!",
  },
  {
    id: 3,
    title: "Customer Support Representative",
    location: "Islamabad, Pakistan",
    type: "Full-Time",
    description:
      "Provide exceptional support to our customers by resolving queries efficiently and maintaining HLC’s commitment to excellence.",
  },
];

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <Navbar />

      {/* Header */}
      <div className="text-center py-20 px-4">
     <motion.h1
  className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#542757] to-[#9b1f6c] mt-6"
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
>
  Careers at HLC
</motion.h1>
        <motion.p
          className="text-gray-600 mt-4 max-w-2xl mx-auto text-base md:text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Join our dynamic team of innovators, designers, and creators who are
          redefining the future of lighting and smart living.
        </motion.p>
      </div>

      {/* How to Start Career Section */}
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl p-8 mb-16 border-l-4 border-pink-500">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          How You Can Start Your Career at HLC
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          At HLC, we believe in nurturing talent and empowering passionate
          individuals to build meaningful careers. Whether you're a fresh
          graduate or an experienced professional, you can be a part of our
          journey towards lighting innovation.
        </p>
        <ul className="list-disc list-inside text-gray-600 space-y-2">
          <li>Browse available job openings below that match your skills.</li>
          <li>Click on “Apply Now” and fill out the short application form.</li>
          <li>Upload your resume and tell us why you’d like to join HLC.</li>
          <li>Our HR team will review your application and get in touch!</li>
        </ul>
        <p className="text-gray-600 mt-4">
          We’re always excited to meet people who are ready to make a
          difference. Even if you don’t see a role that fits, feel free to
          contact us directly.
        </p>
      </div>

      {/* Job Listings */}
      <div className="max-w-6xl mx-auto px-4 pb-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {jobOpenings.map((job) => (
          <motion.div
            key={job.id}
            className="bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl transition duration-300 p-6 flex flex-col justify-between border border-gray-200"
            whileHover={{ scale: 1.03 }}
          >
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                {job.title}
              </h2>
              <p className="text-sm text-gray-500 mb-2">{job.location}</p>
              <span className="inline-block bg-gradient-to-r from-purple-700 to-pink-500 text-white text-xs font-medium px-3 py-1 rounded-full mb-4">
                {job.type}
              </span>
              <p className="text-gray-600 text-sm mb-4">{job.description}</p>
            </div>
            <button
              onClick={() => setSelectedJob(job)}
              className="mt-auto bg-gradient-to-r from-purple-700 to-pink-500 text-white px-5 py-2 rounded-lg font-semibold hover:opacity-90 transition"
            >
              Apply Now
            </button>
          </motion.div>
        ))}
      </div>

      {/* Apply Modal */}
      <AnimatePresence>
        {selectedJob && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 relative"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                Apply for {selectedJob.title}
              </h2>
              <p className="text-sm text-gray-500 mb-6">
                Location: {selectedJob.location} | Type: {selectedJob.type}
              </p>

              <form className="space-y-4">
                <input
                  type="text"
                  placeholder="Full Name"
                  className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                  required
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                  required
                />
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  className="w-full border rounded-lg p-3"
                  required
                />
                <textarea
                  placeholder="Why do you want to join HLC?"
                  className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                  rows="4"
                ></textarea>
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setSelectedJob(null)}
                    className="px-5 py-2 rounded-lg bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300 transition"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-5 py-2 rounded-lg bg-gradient-to-r from-purple-700 to-pink-500 text-white font-semibold hover:opacity-90 transition"
                  >
                    Submit Application
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* WhatsApp Contact Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/923001234567?text=Hello%20HLC%20HR%20Team!%20I%20want%20to%20inquire%20about%20career%20opportunities."
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-5 py-3 rounded-full shadow-lg transition-all duration-300"
        >
          <FaWhatsapp className="text-2xl" />
          <span className="font-semibold">Chat with HR</span>
        </a>
      </div>
    </div>
  );
};

export default Careers;
